import {Text} from "@blueprintjs/core";
import React, {Component} from "react";

export class Verify extends Component {
    render() {
        return <Text>1570782272794</Text>
    }
}


// WEBPACK FOOTER //
// ./src/Verify.js